import { useContext, useEffect, useState } from 'react';
import { getClient } from '../../api-utils/general-utils';
import { MessageContext } from '../../context';
import TitleSection from '../../Header/title-section';
import { isFeatureOn } from '../../utils';
import Uploader from '../../widgets/Uploader';
import infoIcon from '../../common-icons/info-icon.svg';

// import { useRecoilState } from 'recoil';
import {
  isNextButtonDisabledState,
  showSubmittedModalState,
} from '../../recoil-state/application-stage-states';
import PlaidConnector from '../../widgets/PlaidConnector';
import {
  isPlaidConnectedState,
  mainSectionState,
  openOppHasBankStatementsState,
} from '../../recoil-state/general-states';
import { useRecoilValue, useRecoilState } from 'recoil';
import {
  accountRecordState,
  opportunityState,
} from '../../recoil-state/general-states';
import { get } from 'http';
import PayroButton from '../../widgets/PayroButton';
import {
  DefaultApi,
  Opportunity,
} from '../../api-utils/generated-client';

export interface PayroFile {
  filename: string;
}

const BankInfoModal = (props: any) => {
  const [statements, setStatements] = useState<any>();
  const AccountInfo = useRecoilValue(accountRecordState);
  const [uploadedFiles, setUploadedFiles] = useState<string[]>([]);
  const [isConnected, setIsConnected] = useRecoilState(
    isPlaidConnectedState,
  );
  const [mostRecentOpportunity, setMostRecentOpportunity] =
    useState<Opportunity>();
  const [
    checkedNotUploadingBankStatement,
    setCheckedNotUploadingBankStatement,
  ] = useState<boolean>(false);
  const [gotAllFinicity, setGotAllFinicity] = useState(false);
  const [manualBank, setManualBank] = useState(false);
  const [isNextDisabled, setIsNextDisabled] = useRecoilState(
    isNextButtonDisabledState,
  );
  const [showSubmittedModal, setShowSubmittedModal] = useRecoilState(
    showSubmittedModalState,
  );
  const mainSection = useRecoilValue(mainSectionState);
  const [showManualUploader, setShowManualUploader] =
    useState<boolean>(false);
  const messageContext = useContext(MessageContext);

  const finicityFeatureOn: boolean = isFeatureOn('Finicity');
  useEffect(() => {
    const getAccountDetails = async () => {
      const client = await getClient();
      if (!client) {
        return;
      }
      const accountDetails =
        await client.accountsControllerGetMyInfo();
      console.log('The New Account Details', accountDetails);
      return accountDetails;
    };

    getAccountDetails();
  }, [isConnected]);
  const uploadFiles = async (filesToUpload: any[]) => {
    const client = await getClient();

    if (!client) {
      return;
    }

    for (let i = 0; i < filesToUpload.length; i++) {
      let singleFile = filesToUpload[i];
      if (singleFile.size > 10_000_000) {
        messageContext.addMessage({
          level: 'error',
          message: 'File Size is limited to 10MB',
        });
        return;
      }

      try {
        const urlRes =
          await client.documentsControllerUploadStatementsUrl({
            fileName: singleFile.name,
            documentType: 'additional-bank-statement',
          });

        const options = {
          method: 'PUT',
          body: singleFile,
          mode: 'cors',
        };
        const uploadResponse = await fetch(
          urlRes.data,
          options as RequestInit,
        );
        if (!uploadResponse.ok) {
          console.error('Failed to upload file to S3');
          return 'fail';
        }

        client.documentsControllerProcessUploadedPdfBankStatement({
          url: urlRes.data,
          documentType: 'additional-bank-statement',
        });
      } catch {
        messageContext.addMessage({
          level: 'error',
          message: 'PDF uploads only',
        });
        return 'fail';
      }
    }

    getFiles();
  };

  const deleteFile = (fileName: string) => {
    getClient().then((client) => {
      if (!client) {
        return;
      }
      client
        .documentsControllerDeleteStatement({
          fileName,
          documentType: 'additional-bank-statement',
        })
        .then(() => {
          getFiles();
        });
    });
  };

  const getFiles = () => {
    getClient().then((client) => {
      if (!client) {
        return;
      }
      client
        .documentsControllerGetAdditionalBankStatements()
        .then((res: any) => {
          setUploadedFiles(res.data as string[]);
          if (res.data.length >= 1) {
            //console.log('res', res.data.length);
            setShowManualUploader(true);
          }
        });
    });
  };

  useEffect(() => {
    getFiles();
  }, []);
  useEffect(() => {
    setIsNextDisabled(
      isConnected !== 'yes' &&
        uploadedFiles.length < 1 &&
        checkedNotUploadingBankStatement != true,
    );
  });
  const showuploder = () => {
    const pdfshow = document.querySelector('statementlink');
    console.log('rtrtrtrtr', pdfshow);
  };
  const SubmitFunc = async () => {
    console.log('clicked Submit');

    // Check if getClient is defined and is a function

    const client: DefaultApi | undefined = await getClient();
    if (!client) {
      return;
    }

    try {
      client.opportunitiesControllerUpdate({
        bank_statements: true,
      });

      setShowSubmittedModal(true);
    } catch (error) {
      console.error('Error submitting documents:', error);
    }
  };
  useEffect(() => {
    if (showSubmittedModal) {
      console.log('showSubmittedModal is now true!');
      // you can also do other stuff here if needed
    }
  }, [showSubmittedModal]);

  return (
    <>
      <div>
        {!showSubmittedModal &&
          process.env.REACT_APP_SHOW_PLAID === 'yes' && (
            <PlaidConnector justShowConnected />
          )}
        {manualBank || uploadedFiles.length > 0 ? (
          <>
            <div className="showuploader">
              <h4 className="manual-upload-title">
                Upload Your Bank Statements Manually
                {uploadedFiles && uploadedFiles.length <= 0 && (
                  <span
                    className="cancel-right"
                    onClick={() => setManualBank(!manualBank)}
                  >
                    Cancel
                  </span>
                )}
              </h4>
              {isConnected !== 'yes' && (
                <>
                  <Uploader
                    inputChangeHandler={async (files: any) => {
                      setStatements(files);
                      await uploadFiles(files);
                    }}
                    instructionsText="Upload 6 Statements Here"
                    uploadedFiles={uploadedFiles}
                    deleteFile={(fileName: any) =>
                      deleteFile(fileName)
                    }
                    getLatestUploadedFiles={getFiles}
                    isCAEnabled={true}
                    doctype={`additional-bank-statement`}
                  />
                  <div className="bank-modal-submit-wrapper">
                    <PayroButton
                      onClick={() => SubmitFunc()}
                      disabled={uploadedFiles.length <= 0}
                    >
                      Submit
                    </PayroButton>
                  </div>
                </>
              )}
            </div>
          </>
        ) : isConnected == 'no' ? (
          <div className="bankstatement">
            <span>Don't want to connect your bank?</span>{' '}
            <a
              href="#"
              id="statementlink"
              onClick={() => {
                setManualBank(!manualBank);
              }}
            >
              Upload Bank Statements
            </a>
          </div>
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default BankInfoModal;
